export const getFirstPathnameSegment = () => {
    const url = new URL(window.location.href);
    const firstSegment = url.pathname.split("/")[1];

    // Akzeptiert jede UUID-Form (v1-v8, nil), deckungsgleich mit der Backend-Toleranz
    // (server.ts isUuid: /^[\dA-Fa-f-]{36}$/). Bewusst NICHT auf RFC-4122-v4 verengt:
    // die org-id wird clientseitig verbatim als x-ko-organization-id gesendet und hat
    // für die Admin-App KEIN serverseitiges Fallback (geteilter Host → keine Host-
    // Auflösung). Eine gültige Nicht-v4-Tenant-ID (z. B. Mustermann-Fixture, v7-UUIDs)
    // darf daher nicht auf "" geleert werden — sonst brechen alle tenant-scoped Queries.
    return /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(firstSegment)
        ? firstSegment
        : "";
};

export const getSubDomain = () => {
    const url = new URL(window.location.href);
    const subDomain = url.hostname.split(".")[0];

    return subDomain;
};
